export default __webpack_public_path__ + "media/tired.acb0fb22.svg";